export enum PaymentType {
  Smart = 0,
  Cash = 1,
  Iris = 2,
  Api = 3,
}
